<h2 mat-dialog-title>Downloading Scripts</h2>

<div>
    <mat-progress-bar mode="determinate" value="{{completeProgress}}"></mat-progress-bar>
    Downloading ({{currentProcessIndex}} of {{totalProcessCount}})
    <br/> {{processingFileName}}
</div>
<mat-dialog-actions align="end">
    <button  mat-button class="mat-raised-button mat-secondary" mat-dialog-close (click)="cancelProcess()">Cancel</button>&nbsp;&nbsp;
</mat-dialog-actions>
